import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface GridLoadingState {
  isGridLoading: boolean;
}

const initialState: GridLoadingState = {
  isGridLoading: false
};

const gridLoadingSlice = createSlice({
  name: 'gridLoading',
  initialState,
  reducers: {
    gridLoadingStart( state ) {
      state.isGridLoading = true;
    },
    gridLoadingEnd( state ) {
      state.isGridLoading = false;
    },
    setGridLoading( state, action: PayloadAction<boolean> ) {
      state.isGridLoading = action.payload;
    }
  }
});

export const { gridLoadingStart, gridLoadingEnd, setGridLoading } = gridLoadingSlice.actions;
export default gridLoadingSlice.reducer;

// Selector
export const selectGridLoading = ( state: RootState ) => state.spreadsheet.gridLoading.isGridLoading;
